import { Info } from '@mui/icons-material';
import { Box, Chip, Typography } from '@mui/material';

import { useTranslations } from 'context/TranslationContext';

import { getApprovalModeLabel } from 'utils/helpers/approvalsHelpers';

import { baseHeader } from 'styles/components/Common';
import {
  chipDisabledStyle,
  matchedRuleChipsStyle,
  matchedRuleHeaderStyle,
  matchedRulesSectionStyle,
  suppressedRuleCardStyle,
  suppressedRuleNameStyle,
  suppressedNoticeBannerStyle,
  suppressedNoticeIconStyle,
  suppressedNoticeTextStyle
} from 'styles/pages/ApprovalRuleSimulatorStyles';

import { SuppressedRule } from '../../../../utils/interfaces/ApprovalSimulator';

export interface SuppressedRulesSectionProps {
  rules: SuppressedRule[];
  exclusiveRuleName: string;
}

export const SuppressedRulesSection = ({
  rules,
  exclusiveRuleName
}: SuppressedRulesSectionProps) => {
  const { translate } = useTranslations();

  if (rules.length === 0) {
    return null;
  }

  return (
    <Box sx={matchedRulesSectionStyle}>
      <Typography sx={baseHeader}>
        {translate('approvalSimulator.results.suppressedRules', {
          count: rules.length.toString()
        })}
      </Typography>

      <Box sx={suppressedNoticeBannerStyle}>
        <Info sx={suppressedNoticeIconStyle} />
        <Typography sx={suppressedNoticeTextStyle}>
          {translate('approvalSimulator.results.suppressedNotice')}
          <span style={{ fontWeight: 600 }}>{exclusiveRuleName}</span>
        </Typography>
      </Box>

      {rules.map((rule) => (
        <Box key={`suppressed-rule-${rule.id}`} sx={suppressedRuleCardStyle}>
          <Box sx={matchedRuleHeaderStyle}>
            <Typography sx={suppressedRuleNameStyle}>{rule.name}</Typography>

            <Box sx={matchedRuleChipsStyle}>
              {rule.approvalMode && (
                <Chip
                  size="small"
                  label={getApprovalModeLabel(rule.approvalMode, translate)}
                  sx={chipDisabledStyle}
                />
              )}
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
